<template>
  <div class="root">
    <div class="title bg-purple">配载情况</div>
    <el-form class="form" size="mini" :model="dispatch" label-position="left" label-width="70px">
        <el-form-item label="干线司机" prop="driverOneName">{{dispatch.driverOneName}}</el-form-item>
        <el-form-item label="司机电话" prop="driverOnePhone">{{dispatch.driverOnePhone}}</el-form-item>
        <el-form-item label="车牌号码" prop="carNum">{{dispatch.carNum}}</el-form-item>
        <el-form-item label="发车网点" prop="endDeptName">{{dispatch.startDeptName}}</el-form-item>
        <el-form-item label="发车时间" prop="departureTime">{{dispatch.departureTime}}</el-form-item>
        <el-form-item label="经办人"   prop="createUserName">{{dispatch.createUserName}}</el-form-item>
        <el-form-item label="到车时间" prop="arrivalEndDeptTime">{{dispatch.arrivalEndDeptTime}}</el-form-item>
        <el-form-item label="到货时间" prop="unloadOperationTime">{{dispatch.unloadOperationTime}}</el-form-item>
        <el-form-item label="发车备注" prop="remarks">{{dispatch.remarks}}</el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
    props:{
        waybillSplitId:{}
    },
    data(){
        return{
            dispatch:{
                id:'',
                driverOneName:'',
                driverOnePhone:'',
                carNum:'',
                startDeptName:'',
                departureTime:'',
                createUserName:'',
                completeTime:'',
                arrivalEndDeptTime:'',
                remarks:''
            }
        }
    },
    watch:{
        waybillSplitId(val){
            if(!val){
                return
            }
            this.getData()
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        async getData(){
            if(!this.waybillSplitId){
                return
            }
            const res = await this.$API.runDetail({
                number:'admin_waybill_sum_all_dispatch_info_v5',
                waybillSplitId:this.waybillSplitId
            })
            console.log(res)
            this.dispatch = res
            console.log(this.dispatch)
        }
    }
}
</script>

<style lang="less" scoped>
.root{
    width: 100%;
    height: 100%;
    .title{
        display: flex;
        justify-content: center;
        height: 35px;
        line-height: 35px;
    }
    .el-form{
        border-left-width: 1px;
        .el-form-item{
            margin-bottom: 0;
        }
    }
}
</style>